var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("武林秘籍：策略分析")]),_c('QuantJyJyPool',{attrs:{"quant_code":_vm.quant_code,"title":"策略分析","zoom_start":"45"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }